export default __webpack_public_path__ + "assets/paypal.5dc3da21.svg";